import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { PageHeader } from '../../../components';
import { Routes as AppRoutes } from '../../../router/routeMapping';

const menuData = Object.values(
  AppRoutes.protected.REPUTATION_MANAGER.children
).map(({ title, path }) => ({ title, href: path }));

function ReputationManager() {
  const location = useLocation();
  const activePage = menuData.find((page) => page.href === location.pathname);

  return (
    <div className="content container">
      <PageHeader
        title={activePage?.title}
        menuData={menuData}
        breadcrumbData={{
          current: activePage?.title,
          parents: [
            {
              name: AppRoutes.protected.REPUTATION_MANAGER.title,
              href: AppRoutes.protected.REPUTATION_MANAGER.path,
            },
          ],
        }}
      />

      {location.pathname === AppRoutes.protected.REPUTATION_MANAGER.path ? (
        <Navigate to={menuData[0].href} replace />
      ) : (
        <Outlet />
      )}
    </div>
  );
}

export default ReputationManager;
